import _ from "lodash";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "NetworkCall";
import { INSTANCE_URL, itemCount } from "Constants";

export var POLL_LIST = "POLL_LIST";
export var SELECT_LIST_TYPE = "SELECT_LIST_TYPE";
export const POLL_EXPORT_MODAL = "POLL_EXPORT_MODAL";
export const BROADCAST_POLLS = "BROADCAST_POLLS";

export function fetchPolls(
  session,
  select,
  scheduleSessionid,
  pageCount = 0,
  callback
) {
  var perPage = 50;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  // debugger
  var offSetQuery = `limit=${perPage}&offset=${offset}&`;
  var selected = select == "active" ? `isarchived=0` : `isarchived=1`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/poll_questions?filter=((${selected}) AND (eventid=${session.eventid}) AND (sessionid=${scheduleSessionid}))&${offSetQuery}include_count=true&order=displayorder%20ASC%2C%20createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: POLL_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function activePolls(type) {
  let select = "active";
  if (type == "archived") {
    select = "archived";
  }

  return (dispatch) => {
    dispatch({ type: SELECT_LIST_TYPE, payload: { select: select } });
  };
}

export function addPoll(session, values, select, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/poll_questions`;

  values.option3 = values.option3 ? values.option3 : "";
  values.option4 = values.option4 ? values.option4 : "";
  values.polltype = values.polltype ? "checkbox" : "radio";
  values.showresult = values.showresult ? 1 : 0;
  values = { ...values, eventid: session.eventid };

  var body = { resource: values };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function checkActivate(session, scheduleSessionid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/poll_questions?filter=((isarchived=0) AND (eventid=${session.eventid}) AND (sessionid=${scheduleSessionid}))&include_count=true`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function activeArchived(session, pollid, select, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/poll_questions/${pollid}`;
  var body = { isarchived: values, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchPollResult(session, poll, callback) {

  // var pollid = `pollid=${poll.pollid}` ;

  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    pollid: poll.pollid,
    type: "pollResult",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, result: data });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };

  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/poll_results?filter=((${pollid}))&include_count=true`;
  // return (dispatch)=> {
  //     getRequest(url, session, dispatch, (data) => {
  //         callback({success:1, data:data});
  //     }, (error) => {
  //         callback({success:0, error:data})
  //     });
  // };
}

export function fetchPollAnalytics(session, poll, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    pollid: poll.pollid,
    type: "pollResultAnalytics",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, result: data });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updatePollList(session, newArrAvailable, callback) {
  var url = `${INSTANCE_URL}/api/v2/custom_script`;
  var body = { newArrAvailable: newArrAvailable, type: "updatePoll" };
  return (dispatch) => {
    dispatch({
      type: POLL_LIST,
      payload: { resource: newArrAvailable, count: newArrAvailable.length },
    });
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openPollExportModal(showModal) {
  return { type: POLL_EXPORT_MODAL, payload: showModal };
}

export function fetchDownloadPollsInfo(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/custom_script`;
  var body = {
    session: session,
    type: "downloadpollinfo",
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
     
        // dispatch({type:USER_DOWNLOAD_INFO, payload: {data: data.result, count: data.count}});
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchDownloadPollsInfo_v2(session, selectedsession, callback) {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=downloadpollinfo`;
  var body = {
    session: session,
    eventid: session.eventid,
    selectedsession: selectedsession,
    type: "downloadpollinfo",
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        // dispatch({type:USER_DOWNLOAD_INFO, payload: {data: data.result, count: data.count}});
        callback({ success: 1, data: data });
      },
      (error) => {

        callback({ success: 0, message: error });
      }
    );
  };
}

export function downloadResult(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/custom_script`;
  var body = {
    eventid: session.eventid,
    type: "downloadpollresult",
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {

        callback({
          success: 1,
          successS3: response.successS3,
          filename: response.pdfname,
        });
      },
      (error) => {

        //callback({success: 0, message: error});
      }
    );
  };
}

/* Open Live Polls Modal [Reducers name -> broadcastLivePolls] */
export function broadcastPolls(show) {
  return (dispatch) => {
    dispatch({ type: BROADCAST_POLLS, payload: show });
  };
}
